module.exports = __webpack_public_path__ + "static/media/spray-can.c2205837.svg";